import React, { FC, ReactNode } from 'react';
import { DialogContent } from '@mui/material';
import { useStyles } from 'components/shared/dialogs/StepModal/StepModal.styles';

export const StepContent: FC<{ children?: ReactNode }> = ({ children }) => {
  const classes = useStyles();
  return <DialogContent classes={{ root: classes.content }}>{children}</DialogContent>;
};
